import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';
import { config } from '../../config';

const liffId = config.liff_id.regisAutoDebit;

const PaymentDebit = loadable(() => import('./PaymentDebit'), { fallback: null });

const PaymentDebitMethod = loadable(() => import('./PaymentDebitMethod'), { fallback: null });

const PaymentDebitAccount = loadable(() => import('./PaymentDebitAccount'), { fallback: null });

const PaymentCreditCard = loadable(() => import('./PaymentCreditCard'), { fallback: null });

const PaymentCreditCardForm = loadable(() => import('./PaymentCreditCard/form'), { fallback: null });

const PaymentCreditCardOtp = loadable(() => import('./PaymentCreditCard/otp'), { fallback: null });

const PaymentCreditCardComplete = loadable(() => import('./PaymentCreditCard/complete'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function PaymentDebitRoute() {
	return (
		<Routes>
			<Route
				path="/"
				element={<AuthProvider liffId={liffId}>
					<CheckCMSNewVersionLayer>
						<PaymentDebit />
					</CheckCMSNewVersionLayer>
				</AuthProvider>}
			/>
			<Route path="select-method" element={<PaymentDebitMethod />} />
			<Route path="bank-account" element={<PaymentDebitAccount />} />
			<Route path="credit-card-tc" element={<PaymentCreditCard />} />
			<Route path="credit-card-form" element={<PaymentCreditCardForm />} />
			<Route path="credit-card-otp" element={<PaymentCreditCardOtp />} />
			<Route path="credit-card-complete" element={<PaymentCreditCardComplete />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
